import http from "@/utils/request";

export function getProduct(data: Req.getProduct) {
  return http.post<Res.response<Res.getProduct>>({
    url: "/product/list",
    data,
  });
}

export function listSimple(data: Req.listSimple) {
  return http.get<Res.response<Res.listSimple>>({
    url: "/shopgt/listSimple?parentId=" + data.parentId + "&merchantId=" + data.merchantId,
  });
}
export function brandlist(data: Req.brandlist) {
  return http.post<Res.response<Res.brandlist>>({
    url: "/brand/list",
    data,
  });
}
// 添加商品-----
// 渲染规格属性
export function addProduct(data: any) {
  return http.post<Res.response<any>>({
    url: "/product",
    data,
  });
}
export function specList() {
  return http.get<Res.response<Res.specList[]>>({
    url: "/spec/list",
  });
}
// 点击规格渲染表格
export function calculateSpec(data: Req.calculateSpec) {
  return http.post<Res.response<Res.calculateSpec>>({
    url: "/product/calculateSpec",
    data,
  });
}
// 编辑商品

export function edProduct(data: string) {
  return http.get<Res.response<any>>({
    url: "/product/group/v2/" + data,
  });
}

export function putProduct(data: any) {
  return http.put<Res.response<any>>({
    url: "/product",
    data,
  });
}
// 回显三级
export function shopgtedit(data: string) {
  return http.get<Res.response<any>>({
    url: "shopgt/edit?id=" + data,
  });
}

// 商品审核
export function getauditList(data: any) {
  return http.post<Res.response<any>>({
    url: "/auditList",
    data,
  });
}
// 审核详情
export function auditInfo(data: any) {
  return http.get<Res.response<any>>({
    url: "/auditInfo/" + data,
  });
}
// 确定审核
export function auditInsrt(data: any) {
  return http.post<Res.response<any>>({
    url: "/auditInsrt",
    data,
  });
}
//  批量审核
export function batchAuditInsert(data: any) {
  return http.post<Res.response<any>>({
    url: "/batchAuditInsert",
    data,
  });
}
